<div
  *ngFor="
    let extraCompanyContact of project.projectExtraCompanyContacts;
    let i = index;
    let count = count
  "
>
  <div class="d-flex">
    <div class="strong">Bedrijfsnaam + contactpersoon</div>
    <div *ngIf="!disabled && count > 1" class="delete-extra-contact-button">
      <mat-icon
        svgIcon="close"
        class="clickable"
        (click)="deleteExtraCompanyContact(i)"
      ></mat-icon>
    </div>
  </div>
  <mat-form-field appearance="outline">
    <input
      matInput
      [(ngModel)]="extraCompanyContact.company"
      [disabled]="disabled"
      placeholder="Bedrijfsnaam"
      required
    />
  </mat-form-field>
  <mat-form-field appearance="outline">
    <input
      matInput
      [(ngModel)]="extraCompanyContact.contact"
      [disabled]="disabled"
      placeholder="Contactpersoon"
      required
    />
  </mat-form-field>
</div>
<div *ngIf="!disabled">
  <mat-icon
    svgIcon="add"
    class="clickable"
    (click)="addExtraCompanyContact()"
  ></mat-icon>
</div>
